import { Report as SharedReport } from "../report"

export const Report = SharedReport.namespace(`spine`)
